export default {
  login: {
    login: "Registrati",
    quotation: "Benvenuto nel Sistema di Preventivi VERTEX",
    user: "Utente",
    password: "Password",
    logins: "Accesso",
    online: "online",
    offer: "Sistema Prezzi",
    system: "Notifica di Sistema：",
  },
  routers: {
    logOut: "Disconnetti",
    控制台: "Dashboard",
    报价管理: "Gestione preventivi",
    设备价格查阅: "Consulta prezzi attrezzature",
    需求填写: "Compila richiesta",
    表单列表: "Modulo richieste",
    官网管理: "Modulo del sito web",
    表单数据: "Dati modulo",
    系统管理: "Sistema",
    个人资料: "Profilo personale",
    用户列表: "Lista utenti",
    产品结构: "Struttura prodotto",
    配件结构: "Struttura dei componenti",
    汇率: "Tasso di cambio",
    SNI: "Informazioni Notifica di Sistema: ",
    SNImessages: "messaggi in totale",
    Serial: "Numero di serie",
  },
  label: {
    snotifications: "Notifiche di sistema",
    inotifications: "Notifiche di consultazione",
  },
  table: {
    notification: "Aggiungi Notifica",
    Serial: "Numero di serie",
    Title: "Titolo Notifica",
    content: "Contenuto avviso",
    time: "Ora pubblicazione",
    action: "Azioni",
    detail: "Dettagli",
    edit: "Modifica",
    detele: "Elimina",
    progress: "Informazioni Avanzamento Consultazioni Ultimi 30 Giorni:",
    entries: "voci in totale",
    save: "Salva",
    cancel: "Annulla",
  },
  offer: {
    category: "Categoria Prezzo",
    sou: "Cerca",
    add: "Aggiungi prodotto",
    search: "Consulta",
    close: "Chiudi",
    view: "Visualizza",
    code: "Codice Materiale (Alias)",
    name: "Modello Prodotto",
    photo_num: "Numero Disegno Materiale",
    version_num: "Numero Versione Materiale",
    part_number: "Numero di componenti",
    total_number: "Numero totale di parti",
    weight: "peso singolo teorico (kg)",
    power: "Potenza (kW)",
    price: "Categoria Prezzo",
    price1: "Prezzo (USD)",
    detail: "Spiegazione Dettagliata",
    data: "Nessun Dato Disponibile",
    Level1: "Prezzo Permesso Livello 1",
    Level2: "Prezzo Permesso Livello 2",
    Level3: "Prezzo Permesso Livello 3",
    Level4: "Prezzo Permesso Livello 4",
    Level5: "Prezzo Permesso Livello 5",
    pro: "Modifica prodotto",
    zui: "Prezzo minimo",
    gao: "Prezzo massimo",
    can: "Lista parametri prodotto",
    pdf: "Documentazione del prodotto",
    zan: "Nessun parametro attualmente disponibile",
    tuji: "Foto",
    document: "Documentazione del prodotto",
    ptype: "Tipo di prodotto",
    poles: "Numero di poli‌",
  },
  user: {
    username: "Nome utente",
    nickname: "Soprannome",
    Information: "Modifica Informazioni",
    resat: "Reimposta Password",
    User: "Aggiungi Utente",
    submit: "Invia",
    cancel: "Annulla",
    new: "Nuova Password",
    old: "Vecchia Password",
  },
  userList: {
    moble: "Numero di telefono",
    email: "Email",
    level: "Livello permessi",
    time: "Ora creazione",
    Subcategory: "Aggiungi Sottocategoria",
    Category: "Elimina questa Categoria",
    edit: "Modifica questa Categoria",
    add: "aggiungi",
    name: "Nome categoria:",
    shu: "Caricamento dati...",
    audit: "Permessi pagina",
  },
  official: {
    country_Code: "Codice Paese",
    country: "Paese",
    desc: "Descrizione",
    export: "Esporta",
    discount: "sconto",
    rate: "tasso di cambio",
    title: "Si prega di selezionare il tipo di tasso di cambio da convertire.",
    prompt:
      "Inserisci un numero compreso tra 0 e 100, con al massimo una cifra decimale.",
    select: "Si prega di selezionare prima un prodotto!",
  },
  form: {
    name: "Nome",
    phone: "Informazioni di contatto",
    email: "Email",
    image: "Immagine di riferimento",
    Information: "Informazioni richiesta",
    dispose: "Gestisci",
    can: "Parametro principale",
    clear: "Pulisci",
    time: "Ora",
    chu: "In attesa",
    li: "Elaborato",
    current_url: "Sito web",
    titime: "Ora invio",
    sttime: "Ora inizio",
    endtime: "Ora fine",
    rate: "Tasso di cambio",
    agency: "Offerta agenzia",
    jsdi: "Preventivo Commercio Internazionale Macchina Completa",
    jsde: "Accessori offerta commerciale",
    currency: "RMB",
    ai: "Ops ~~ La pagina che stai cercando non è sulla Terra...",
    fan: "Torna alla pagina di accesso",
    quan: "Non hai accesso alla pagina, contatta l'amministratore!",
  },
  elMessage: {
    errMsg: "¡Has agotado tu cuota de exportación para hoy!",
  },
};
